/**
 * Where verified users land after OTP success.
 *
 * Invite links always win. Otherwise use `nextSetupPath` when safe;
 * `/setup` only resolves when chat-first onboarding is enabled in the SPA build.
 */

export function resolvePostVerificationDestination({
  pendingInviteToken,
  chatFirstSetupEnabled,
  nextSetupPath,
}) {
  const pendingTrimmed = pendingInviteToken != null ? String(pendingInviteToken).trim() : ''

  if (pendingTrimmed.length > 0) {
    return {
      path: `/join?token=${encodeURIComponent(pendingTrimmed)}`,
      clearInviteToken: true,
    }
  }

  const defaultSetup = '/setup'
  let candidate =
    typeof nextSetupPath === 'string' && nextSetupPath.trim().length > 0 ? nextSetupPath.trim() : defaultSetup

  if (candidate === '/setup' && !chatFirstSetupEnabled) {
    return { path: '/dashboard', clearInviteToken: false }
  }

  return { path: candidate, clearInviteToken: false }
}
